<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » フロア・表示グループ情報詳細（追加・編集）の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>フロア・表示グループ情報詳細（追加・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/floor-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          IDを設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 説明
        </div>
        <div class="manual-explain">
          情報についての説明を設定します。<br>
          ※ユーザサイトでは利用しない項目となります。メモ的な意味合いでご利用ください。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 建物・カテゴリ
        </div>
        <div class="manual-explain">
          建物・カテゴリ情報を選択します。<br>
          ※<a [href]="hallDialogLink">建物・カテゴリ情報画面</a>で登録された情報から選択します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 詳細
        </div>
        <div class="manual-explain">
          詳細を設定します。<br>
          編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> マップ情報
        </div>
        <div class="manual-explain">
          マップ情報を設定します。<br>
          マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> MAPページに位置を表示する
        </div>
        <div class="manual-explain">
          チェックを入れることで、MAPページにGoogleMapを表示しピンを立てます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> 外部リンク
        </div>
        <div class="manual-explain">
          外部リンクの名称、URLを設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>、<a [href]="urlDialogLink">編集用ダイアログ（URL）</a>を開き設定します。<br>
          外部リンクを表示させたい場合は「外部リンクを使用する」にチェックを入れて下さい。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> 開催期間
        </div>
        <div class="manual-explain">
          開催期間を設定します。<br>
          ※ユーザサイトでは利用しない項目となります。メモ的な意味合いでご利用ください。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> フロア・表示グループ画像ファイル
        </div>
        <div class="manual-explain">
          フロア・表示グループのメイン画像を設定します。<br>
          ファイル追加ボタンからファイルを選択します。<br>
          ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
          ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
          メイン画像は複数登録可能です。複数登録した場合、画像はスライド表示されます。<br>
          また、フロア・表示グループ画像はドラッグ&ドロップで並び替えが可能です。<br>
          「フロア・表示グループファイルを拡大表示する」にチェックを入れると、フロアページで画像をクリックした時に拡大表示することができます。<br>
          ※画像の推奨サイズ（縦横比）は以下になります。<br>
          &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> 展示リスト
        </div>
        <div class="manual-explain">
          展示物を設定します。<br>
          展示リスト追加ボタンから展示物を選択します。<br>
          ※展示物は、<a [href]="exhibitDialogLink">展示情報画面</a>で事前に登録してある必要があります。<br>
          展示リストはドラッグ&ドロップで並び替えが可能です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/M.png"> 更新ボタン
          </div>
          <div class="manual-explain">
            クリックすることで編集内容が更新されます。
          </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Floor/Display Group Details (Add/Edit)
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Floor/Display Group Details (Add/Edit)</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_floor-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button will close the dialog.<br>
          Edited content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Set the ID.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Description
        </div>
        <div class="manual-explain">
          Set a description of the information.<br>
          * This field is not used on the user site and serves as a memo field.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Building/Category
        </div>
        <div class="manual-explain">
          Select building/category information.<br>
          * Select from the information registered on the <a [href]="hallDialogLink">Building/Category Information Screen</a>.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Floor/Display Group
        </div>
        <div class="manual-explain">
          Set the Floor/Display Group name.<br>
          Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Details
        </div>
        <div class="manual-explain">
          Set the details.<br>
          Open the <a [href]="descDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Map Information
        </div>
        <div class="manual-explain">
          Set map information.<br>
          Specify using search keywords or latitude and longitude within the map.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> Display Location on MAP Page
        </div>
        <div class="manual-explain">
          Check this box to display Google Maps with a pin on the MAP page.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> External Links
        </div>
        <div class="manual-explain">
          Set the name and URL for external links.<br>
          Open the <a [href]="nameDialogLink">Edit Dialog (Name)</a> or <a [href]="urlDialogLink">Edit Dialog (URL)</a> from the edit button to configure them.<br>
          Check "Use External Links" to display the external links.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> Event Period
        </div>
        <div class="manual-explain">
          Set the event period.<br>
          * This field is not used on the user site and serves as a memo field.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> Floor/Display Group Image Files
        </div>
        <div class="manual-explain">
          Set the main images for the Floor/Display Group.<br>
          Select files using the Add File button.<br>
          * Files must be uploaded in advance on the <a [href]="uploaderLink">Upload File Screen</a>.<br>
          * Images can be set for each language. If no image exists for the selected language, the English image will be displayed. If no English image is available, the Japanese image will be shown.<br>
          Multiple main images can be registered. When multiple images are registered, they will be displayed as a slideshow.<br>
          Floor/Display Group images can be reordered using drag-and-drop.<br>
          Check "Expand Floor/Display Group File on Click" to enable image enlargement when clicked on the Floor page.<br>
          * Recommended image size (aspect ratio):<br>
          &nbsp;&nbsp;Main Image: 1:1 (e.g., height 1400px, width 1400px).
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> Exhibit List
        </div>
        <div class="manual-explain">
          Set exhibits.<br>
          Use the Add Exhibit button to select exhibits.<br>
          * Exhibits must be registered in advance on the <a [href]="exhibitDialogLink">Exhibit Information Screen</a>.<br>
          The exhibit list can be reordered using drag-and-drop.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button will apply the edited content.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>